import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { api } from "../../../config";
import { useReactToPrint } from "react-to-print";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { resetBranchState, getBranch } from "../../../store/branch/action";
import { resetTransferState, getTransfer as onGetTransfers, addNewTransfer as onAddNewTransfer, updateTransfer as onUpdateTransfer, deleteTransfer as onDeleteTransfer, getTransferLoading, resetTransferCreateState } from "../../../store/transfer/action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { resetClientState, getClient } from "../../../store/client/action";

import logoDark from "../../../assets/images/logo-dark.png";
import logoLight from "../../../assets/images/logo-light.png";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
import PrintDoc from "./PrintDoc";

const Transfer = () => {
  const printRef = useRef(null);
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [modalApprove, setModalApprove] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");

  const [productInventoryList, setProductInventoryList] = useState([]);
  const [productInventoryDetailItem, setProductInventoryDetailItem] = useState([]);

  const [searchBranch, setSearchBranch] = useState("");

  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, transfers, transferAdded, isTransferCreated, isTransferSuccess, loading, error, companies, companyLoading, branches, branchLoading, productVarians, productVarianLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    transferAdded: state.Transfer.transferAdded,
    transfers: state.Transfer.transfers,
    isTransferCreated: state.Transfer.isTransferCreated,
    isTransferSuccess: state.Transfer.isTransferSuccess,
    loading: state.Transfer.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    error: state.Transfer.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [transferList, setTransferList] = useState([]);
  const [transfer, setTransfer] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusTransfer, setStatusTransfer] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [originalFiles, setOriginalFiles] = useState([]);
  const [productList, setProductList] = useState([]);
  const [transferDetailItem, setTransferDetailItem] = useState([]);
  const [invDocImg, setInvDocImg] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [branchList, setBranchList] = useState([]);

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [modalMedia, setModalMedia] = useState(false);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const statusAdjustmentData = [
    {
      options: [
        { label: "PLUS", value: "PLUS" },
        { label: "MINUS", value: "MINUS" },
      ],
    },
  ];

  const typeSelectData = [
    {
      options: [
        { label: "Adjustment", value: "Adjustment" },
        { label: "Production", value: "Production" },
        { label: "Lost", value: "Lost" },
        { label: "Damage", value: "Damage" },
        { label: "Other", value: "Other" },
      ],
    },
  ];

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredTransfers = transfers;
      if (type !== "all") {
        filteredTransfers = transfers.filter((transfer) => transfer.transfer_status.name === type);
      }
      setTransferList(filteredTransfers);
    }
  };

  useEffect(() => {
    if (branchSelected && companySelected) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetTransferState());
      dispatch(onGetTransfers({ type: "Adjustment", branchId: branchSelected?.value ?? "" }));
      handleGetProductVariant(companySelected?.value ?? "");
    }
  }, [branchSelected, companySelected]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetBranch = useCallback(
    (id) => {
      dispatch(resetBranchState());
      dispatch(getBranch({ companyId: id, status: 2 }));
    },
    [dispatch]
  );

  const handleGetProductVariant = (companyId) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, type: "referral" }));
  };

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      var productVarianData = [];
      var opt = [];
      productVarians.forEach((item, key) => {
        const varian = item.pvar_product ? item.pvar_product : "";
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const price = item.price;
        const brandId = item.brandId;
        const productId = item.productId;
        let option_name = "";
        item.pvar_options &&
          item.pvar_options.forEach((i, k) => {
            option_name += i.name + "/";
          });
        if (item.typeId !== 1) {
          opt.push({ label: varian.name, name: varian.name + " " + option_name.slice(0, -1), barcode: barcode, sku: sku, value: id, price: price, brandId: brandId, productId: productId });
        }
      });
      var option = { options: opt };
      productVarianData.push(option);
      setProductList(productVarianData);
    }
  }, [productVarians]);

  useEffect(() => {
    if (!isEmpty(transfers)) {
      let filteredTransfers = transfers;
      if (activeTypeTab !== "all") {
        filteredTransfers = transfers.filter((transfer) => transfer.transfer_status.name === activeTypeTab);
      }
      setTransferList(filteredTransfers);
    }
    else
    {
      setTransferList([]);
    }
  }, [transfers]);

  useEffect(() => {
    setTransfer(transferAdded);
  }, [transferAdded]);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  useEffect(() => {
    var data = [];
    var opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);
    setBranchList(data);
  }, [branches]);

  const toggleBranch = (val) => {
    setSearchValue("");
    setFilterDate(null);
    dispatch(onGetTransfers({ type: "Adjustment", branchId: val }));
  };

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  const onClickDelete = (transfer) => {
    setTransfer(transfer);
    setDeleteModal(true);
  };

  const handleDeleteTransfer = () => {
    if (transfer) {
      dispatch(onDeleteTransfer(transfer));
      setDeleteModal(false);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleApprove = useCallback(() => {
    if (modalApprove) {
      setModalApprove(false);
    } else {
      setModalApprove(true);
    }
  }, [modalApprove]);

  const toggleHistory = useCallback(() => {
    if (modalHistory) {
      setModalHistory(false);
    } else {
      setModalHistory(true);
    }
  }, [modalHistory]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setTransfer(null);
      setOriginalFiles([]);
      setTransferDetailItem([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handleTransferClick = useCallback(
    (arg, type) => {
      const data = arg;
      let transferDetailList = [];
      if (data.transfer_detail !== null) {
        data.transfer_detail.forEach((e) => {
          const bcode = e.barcode === null ? 0 : e.barcode;
          transferDetailList.push({
            detailId: e.productInventoryBranchId,
            itemId: e.productVarianId,
            item: { label: e?.transfer_detail_product?.name, value: e.productVarianId, name: e.name, sku: e.sku, barcode: bcode, price: e.price, brandId: e.brandId, productId: e.productId },
            amount: parseFloat(e.price),
            quantity: parseFloat(e.quantity),
            quantity_available: parseFloat(e.quantity),
            total: 0,
            name: e?.transfer_detail_product?.name,
            uom: e?.transfer_detail_product?.product_uom?.name,
            sku: e.sku,
            barcode: bcode,
            brandId: e.brandId,
          });
        });
      }
      setProductInventoryDetailItem(transferDetailList);

      let files = [];
      for (const f of data.transfer_file) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }
      setInvDocImg(files);

      let arrUnit = [];
      if (data.unit) {
        data.unit.forEach((item) => {
          var obj = { label: item.name, name: item.name, barcode: item.barcode, sku: item.sku, value: item.productId, price: item.price, brandId: item.brandId, productId: item.productId };
          arrUnit.push(obj);
        });
      }

      setTransfer({
        id: data.id,
        code: data.code,
        type: {
          label: data.type,
          value: data.type,
        },
        transaction_no: data.transaction_no,
        transactionat: data.transactionat,
        description: data.description,
        unit: arrUnit,
        items: transferDetailList,
        client: data.transfer_client && {
          label: data.transfer_client.name,
          value: data.transfer_client.id,
        },
        company: data.transfer_company && {
          label: data.transfer_company.name,
          value: data.transfer_company.id,
        },
        branch: data.transfer_from && {
          label: data.transfer_from.name,
          value: data.transfer_from.id,
        },
        toBranch: data.transfer_to && {
          label: data.transfer_to.name,
          value: data.transfer_to.id,
        },
        adjustment: data.adjustment && {
          label: data.adjustment,
          value: data.adjustment,
        },
      });

      switch (type) {
        case "detail":
          toggleDetail();
          break;
        default:
          setIsEdit(true);
          toggle();
          break;
      }
    },
    [dispatch, handleGetBranch, toggleDetail]
  );

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
        filterable: false,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      handleTransferClick(data, "detail");
                      setInfo(data);
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                      toggleHistory();
                    }}
                  >
                    <i className=" ri-history-line fs-15"></i>
                  </Button>
                  {parseInt(cellProps.row.original.statusId) < 2 && (
                    <>
                      <Button
                        color="light"
                        className="btn-sm"
                        onClick={() => {
                          handleTransferClick(data);
                        }}
                      >
                        <i className="ri-edit-2-line fs-15"></i>
                      </Button>
                      <Button
                        color="light"
                        className="btn-sm"
                        onClick={() => {
                          onClickDelete(data);
                        }}
                      >
                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                      </Button>
                    </>
                  )}
                  <DropdownToggle tag="button" className={data.statusId === 5 || data.statusId === 6 || data.statusId === 7 ? "d-none" : "btn btn-sm btn-light"} split></DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      onClick={() => {
                        data.actionTitle = `You are going to set transfer transaction of ${data.transfer_to.name} #${data.code} as COMPLETED`;
                        data.statusTransferId = 5;
                        setTransfer(data);
                        toggleApprove();
                      }}
                    >
                      COMPLETED
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem
                      onClick={() => {
                        data.actionTitle = `You are going to CANCEL transfer transaction of ${data.transfer_to.name}  #${data.code} `;
                        data.statusTransferId = 6;
                        setTransfer(data);
                        toggleApprove();
                      }}
                    >
                      CANCELED
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        data.actionTitle = `You are going to set transfer transaction of ${data.transfer_to.name} #${data.code} as RETURNED`;
                        data.statusTransferId = 7;
                        setTransfer(data);
                        toggleApprove();
                      }}
                    >
                      RETURNED
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              </ButtonGroup>

              {cellProps.row.original.statusId === 1 && (
                <button
                  className="btn-label btn btn-sm btn-soft-success fs-12 me-0"
                  onClick={() => {
                    let data = cellProps.row.original;
                    data.statusTransferId = 2;
                    setTransfer(data);
                    toggleApprove();
                  }}
                >
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> APPROVE
                </button>
              )}

              {cellProps.row.original.statusId === 2 && (
                <button
                  className="btn-label btn btn-sm btn-soft-success fs-12 me-0"
                  onClick={() => {
                    let data = cellProps.row.original;
                    data.statusTransferId = 3;
                    setTransfer(data);
                    toggleApprove();
                  }}
                >
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>
                  {"BARANG DIKELUARKAN"}
                </button>
              )}
            </div>
          );
        },
      },
      {
        Header: "Transfer No",
        accessor: "transaction_no",
        filterable: true,
        Cell: (cellProps) => (
          <Link
            to="#"
            className="fw-semibold"
            onClick={() => {
              let data = cellProps.row.original;
              handleTransferClick(data, "detail");
            }}
          >
            {cellProps.row.original.transaction_no}
          </Link>
        ),
      },
      {
        id: "Tanggal",
        Header: "Tanggal",
        accessor: "transactionat",
        filterable: false,
        Cell: (data) => {
          return handleValidDate(data.row.original.transactionat);
        },
      },
      {
        Header: "Type",
        accessor: "type",
        filterable: true,
        Cell: (cell) => {
          return <span className={cell.value === "Adjustment" ? "badge text-uppercase badge-soft-warning" : "badge text-uppercase badge-soft-primary"}> {cell.value}</span>;
        },
      },
      {
        Header: "Sender",
        accessor: "transfer_from.name",
        filterable: true,
      },
      {
        Header: "Receiver",
        accessor: "transfer_to.name",
        filterable: true,
      },
      {
        id: "Detail",
        Header: "Detail",
        accessor: (data) => JSON.stringify(data.transfer_detail),
        filterable: true,
      },
      {
        Header: "Qty ",
        accessor: "sub_amount",
        filterable: true,
        Cell: (data) => {
          let qty = 0;
          data.row.original.transfer_detail.forEach((element) => {
            qty += parseFloat(element.quantity, 2);
          });
          return <span className="fw-semibold">{qty}</span>;
        },
      },
      {
        Header: "Status",
        accessor: "transfer_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "CONFIRMED":
              return <span className="badge text-uppercase badge-soft-secondary">{cell.value}</span>;
            case "SHIPPED":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "RECEIVED":
              return <span className="badge text-uppercase badge-soft-primary">{cell.value}</span>;
            case "COMPLETED":
              return <span className="badge text-uppercase badge-soft-success">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
          }
        },
      },
    ],
    [handleTransferClick, toggleApprove, toggleHistory]
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: transferList,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Detail"],
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        sortBy: [
          {
            id: "Tanggal",
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusTransfer.value ? statusTransfer.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      type: "Adjustment",
    };
    dispatch(onGetTransfers(param));
  }

  function handleResetFilter() {
    setFilterDate(null);
    setTransferList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
    dispatch(resetTransferState());
    dispatch(onGetTransfers({ type: "Adjustment", branchId: branchSelected?.value ?? "" }));
    handleGetProductVariant(companySelected?.value ?? "");
  }

  const validationApprove = useFormik({
    enableReinitialize: true,
    initialValues: {
      approval_note: "",
    },
    onSubmit: (values) => {
      if (transfer) {
        transfer.setApprove = true;
        transfer.approval_note = values.approval_note;
        dispatch(onUpdateTransfer(transfer));
      }
      validationApprove.resetForm();
      toggleApprove();
    },
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      client: (transfer && transfer.client) || clientSelected,
      company: (transfer && transfer.company) || companySelected,
      id: (transfer && transfer.id) || 0,
      transactionat: (transfer && transfer.transactionat) ?? "",
      type: (transfer && transfer.type) ?? "",
      description: (transfer && transfer.description) ?? "",
      branch: (transfer && transfer.branch) || branchSelected,
      toBranch: (transfer && transfer.toBranch) ?? "",
      unit: (transfer && transfer.unit) ?? "",
      items: (transfer && transfer.items) ?? "",
      adjustment: (transfer && transfer.adjustment) ?? "",
    },
    validationSchema: Yup.object({
      branch: Yup.object().required("Silahkan isi cabang").nullable(true),
      adjustment: Yup.object().required("Silahkan isi jenis penyesuaian").nullable(true),
      company: Yup.object().required("Silahkan isi perusahaan").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        let dataEdit = {
          id: values.id,
          statusTransferId: 1,
          type: values.type.value,
          transactionat: values.transactionat,
          adjustment: values.adjustment && values.adjustment.value,
          description: values.description,
          clientId: values.client.value,
          companyId: values.company.value,
          fromBranchId: values.branch.value,
          toBranchId: values.toBranch.value,
          unit: values.unit,
          transfer_detail: JSON.stringify(values.items) || [],
          files: invDocImg.length > 0 ? invDocImg : [],
        };
        dispatch(onUpdateTransfer(dataEdit));
        toggle();
      } else {
        let dataSubmit = {
          statusTransferId: 1,
          type: values.type.value,
          transactionat: values.transactionat,
          adjustment: values.adjustment && values.adjustment.value,
          description: values.description,
          clientId: values.client.value,
          companyId: values.company.value,
          fromBranchId: values.branch.value,
          toBranchId: values.toBranch.value,
          unit: values.unit,
          transfer_detail: JSON.stringify(values.items) || [],
          files: invDocImg.length > 0 ? invDocImg : [],
        };

        dispatch(onAddNewTransfer(dataSubmit));
        toggle();
      }
      validation.resetForm();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteTransfer(element.value));
    });
    checkall.checked = false;
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = invDocImg.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setInvDocImg(newState);
    } else {
      const index = invDocImg.findIndex((fl) => fl.filename === file.filename);
      setInvDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const handleSelectFile = (file) => {
    setInvDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  useEffect(() => {
    const checkall = document.getElementById("checkBoxAllInventory");
    const resultF = productInventoryList.every((el) => el.checked !== true);
    if (checkall !== null) {
      if (resultF) {
        checkall.checked = false;
      }
    }
  }, [productInventoryList]);

  const onClickDeleteDetailItem = (index) => {
    validation.values.items.splice(index, 1);
    validation.setFieldValue("items", validation.values.items);
  };

  const handleBtnQtyDetail = (type, i) => {
    if (type === "add") {
      let valReduce = parseFloat(validation.values.items[i].quantity) + 1;
      validation.values.items[i].quantity = valReduce;
      validation.values.items[i].total = validation.values.items[i].amount * valReduce;
    } else if (type === "reduce") {
      let valAdd = parseFloat(validation.values.items[i].quantity) > 0 ? parseFloat(validation.values.items[i].quantity) - 1 : parseFloat(validation.values.items[i].quantity);
      validation.values.items[i].quantity = valAdd;
      validation.values.items[i].total = parseFloat(validation.values.items[i].amount) * valAdd;
    }
  };

  const handleQuantityDetail = (e, i) => {
    let val = e.target.value;
    if (!isNaN(val)) {
      validation.values.items[i].quantity = val;
      validation.values.items[i].total = validation.values.items[i].amount * val;
    } else {
      validation.values.items[i].quantity = 0;
      validation.values.items[i].total = validation.values.items[i].amount * 0;
    }
  };

  const handlePurchaseDetailAdd = () => {
    validation.setFieldValue("items", [
      ...validation.values.items,
      {
        detailId: 0,
        itemId: 0,
        item: {
          label: "Pilih Produk",
          value: 0,
          name: "Pilih Produk",
          sku: "",
          barcode: "",
          amount: 0,
          brandId: 0,
          productId: 0,
        },
        amount: 0,
        quantity_available: 0,
        quantity: 0,
        total: 0,
        name: "",
        disable: false,
        sku: "",
        barcode: "",
        brandId: 0,
      },
    ]);
  };

  document.title = "Penyesuaian Stok | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={transferList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteTransfer} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Persediaan" pageTitle="Data Penyesuaian Stock" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className="btn btn-warning add-btn me-2"
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-barcode-box-line me-1 align-bottom fs-14"></i> PENYESUAIAN STOK
            </button>
            <button type="button" className="btn btn-success" onClick={() => setIsExportCSV(true)}>
              <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
            </button>
            {/* <button className="btn btn-soft-danger" onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
                    </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={12}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className=" ri-group-line me-1 align-bottom fs-14"></i> ALL
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "CONFIRMED");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> CONFIRMED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "6" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("6", "COMPLETED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> COMPLETED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "7" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("7", "CANCELED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> CANCELED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "8" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("8", "RETURNED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> RETURNED
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={7}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>

                        <Col sm={3}>
                          <div className="search-box me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              value={filterDate}
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            <i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={1}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          const detail = JSON.parse(row.values.Detail);
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                              {(detail || [])
                                .sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" }))
                                .map((o, i) => {
                                  return (
                                    <tr key={i} className="bg-light">
                                      <td colSpan={3} className="p-2"></td>
                                      <td colSpan={6} className="text-start fs-11 p-2">
                                        {o?.transfer_detail_product?.name}{" "}
                                        <span className="text-muted ms-2">
                                          ({parseFloat(o.quantity)} {o.transfer_detail_product?.product_uom?.name})
                                        </span>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>

                <Modal id="showModalTransferAdjustment" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    FORM PENYESUAIAN STOK {validation.values.branch.label} &nbsp;
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <CardBody>
                        <Row>
                          <Col lg={5} sm={5}>

                              <Label htmlFor="branch" className="form-label">
                                Tanggal Penyesuaian
                              </Label>
                            <div className="mb-3">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Tgl Pengeluaran"
                                options={{
                                  mode: "single",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  validation.setFieldValue("transactionat", dateStr);
                                }}
                                value={validation.values.transactionat}
                              />
                              {validation.touched.transactionat && validation.errors.transactionat && (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.transactionat}
                                </p>
                              )}
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="branch" className="form-label">
                                Cabang / Proyek
                              </Label>
                              <Select
                                name="branch"
                                placeholder="Pilih Cabang / Proyek Penerima"
                                value={validation.values.branch}
                                isDisabled={branchList.length > 0 ? false : true}
                                onChange={(e) => {
                                  validation.setFieldValue("branch", e);
                                  validation.setFieldValue("items", []);
                                }}
                                options={branchList}
                              ></Select>
                              {validation.touched.branch && validation.errors.branch && (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.branch}
                                </small>
                              )}
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="adjustment" className="form-label">
                                Pengurangan / Penambahan Barang
                              </Label>
                              <Select
                                name="adjustment"
                                placeholder="Pilih Jenis Penyesuaian"
                                value={validation.values.adjustment}
                                onChange={(e) => {
                                  validation.setFieldValue("adjustment", e);
                                }}
                                options={statusAdjustmentData}
                              ></Select>
                              {validation.touched.adjustment && validation.errors.adjustment && (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.adjustment}
                                </small>
                              )}
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="type-field" className="form-label">
                                Jenis Penyesuaian
                              </Label>
                              <Select
                                name="type"
                                value={validation.values.type}
                                placeholder="Pilih Jenis Penyesuaian"
                                onChange={(e) => {
                                  validation.setFieldValue("type", e);
                                }}
                                options={typeSelectData}
                              ></Select>
                              {validation.touched.type && validation.errors.type && (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.type}
                                </small>
                              )}
                            </div>
                            <div className="mb-3 d-flex justify-content-between">
                              <Label htmlFor="education" className="form-label">
                                Dokumen Stok Opname
                              </Label>
                              <button
                                type="button"
                                className="btn btn-sm btn-label btn-soft-success"
                                onClick={() => {
                                  toggleMedia();
                                }}
                              >
                                <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                              </button>
                            </div>
                            {invDocImg.map((f, i) => {
                              if (f.isDeleted) {
                                return null;
                              } else {
                                return (
                                  <div key={i} className="border-bottom mb-3">
                                    <div className="d-flex justify-content-between mb-3 align-items-center">
                                      <div className="me-2">
                                        <img src={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                      </div>
                                      <div className="text-truncate">{f.filename}</div>
                                      <div>
                                        <Link
                                          to="#"
                                          className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                          onClick={(e) => {
                                            handleDeleteFile(f);
                                          }}
                                        >
                                          <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                            <div className="mb-3">
                              <Label htmlFor="address-field" className="form-label">
                                Keterangan
                              </Label>
                              <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan " name="description" rows={3} value={validation.values.description ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.description && validation.errors.description ? true : false} />
                              {validation.touched.description && validation.errors.description && (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.description}
                                </small>
                              )}
                            </div>
                          </Col>
                          <Col lg={7} sm={7}>
                            <div>
                              <Table className="invoice-table table-borderless table-nowrap mb-0">
                                <thead className="align-middle">
                                  <tr className="table-active">
                                    <th scope="col" style={{ width: "20px" }}>
                                      #
                                    </th>
                                    <th scope="col" className="text-center">
                                      Produk
                                    </th>
                                    <th scope="col" className="text-center" style={{ width: "120px" }}>
                                      Jumlah
                                    </th>
                                    <th scope="col" className="text-center" style={{ width: "35px" }}></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {validation.values.items &&
                                    validation.values.items.map((o, i) => {
                                      return (
                                        <tr key={"purchaseDetailItem-" + i} className="product">
                                          <th scope="row" className="product-id">
                                            {i + 1}
                                          </th>
                                          <td className="text-start" style={{ verticalAlign: "middle" }}>
                                            <div>
                                              <Select
                                                name="item"
                                                isDisabled={validation.values.items[i].disable}
                                                value={validation.values && validation.values.items ? validation.values.items[i].item : {}}
                                                placeholder="Pilih Produk"
                                                onChange={(e) => {
                                                  validation.values.items[i].item = e;
                                                  validation.values.items[i].sku = e.sku;
                                                  validation.values.items[i].barcode = e.barcode;
                                                  validation.values.items[i].itemId = e.value;
                                                  validation.values.items[i].brandId = e.brandId;
                                                  validation.values.items[i].amount = parseFloat(e.price);
                                                  validation.values.items[i].detailId = e.productInventoryBranchId;
                                                  validation.setFieldValue("items", validation.values.items);
                                                }}
                                                options={productList}
                                              ></Select>
                                            </div>
                                          </td>
                                          <td style={{ verticalAlign: "middle" }}>
                                            <div className="input-step">
                                              <button
                                                type="button"
                                                className="minus"
                                                disabled={validation.values.items[i].disable}
                                                onClick={() => {
                                                  handleBtnQtyDetail("reduce", i);
                                                  validation.setFieldValue("items", validation.values.items);
                                                }}
                                              >
                                                –
                                              </button>
                                              <Input
                                                name="quantity"
                                                disabled={validation.values.items[i].disable}
                                                placeholder="Qty"
                                                type="text"
                                                className="product-quantity border-0"
                                                style={{ width: "100px" }}
                                                onFocus={(e) => e.target.select()}
                                                value={validation.values && validation.values.items ? validation.values.items[i].quantity : validation.values.items[i].quantity_available}
                                                onChange={(e) => {
                                                  handleQuantityDetail(e, i);
                                                  validation.setFieldValue("items", validation.values.items);
                                                }}
                                                onBlur={validation.handleBlur}
                                              />
                                              <button
                                                type="button"
                                                className="plus"
                                                disabled={validation.values.items[i].disable}
                                                onClick={() => {
                                                  handleBtnQtyDetail("add", i);
                                                  validation.setFieldValue("items", validation.values.items);
                                                }}
                                              >
                                                +
                                              </button>
                                            </div>
                                          </td>
                                          <td className={"product-removal"}>
                                            <Link
                                              to="#"
                                              className="text-danger btn-icon btn btn-soft-danger flex-shrink-0"
                                              onClick={() => {
                                                onClickDeleteDetailItem(i);
                                              }}
                                            >
                                              <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                            </Link>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </Table>
                              <div className="justify-content-end mt-3">
                                <Link
                                  to="#"
                                  className="btn btn-soft-success fw-medium w-25"
                                  id="add-item"
                                  onClick={() => {
                                    handlePurchaseDetailAdd();
                                  }}
                                >
                                  <i className="ri-add-fill me-1 align-bottom"></i> Tambah Produk
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            toggle();
                          }}
                        >
                          {" "}
                          CLOSE{" "}
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            {!!isEdit ? "UPDATE PENYESUAIAN STOK" : "SIMPAN PENYESUAIAN STOK"}
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                {" "}
                                Loading...{" "}
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModalHistory" isOpen={modalHistory} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleHistory}>
                    Transfer Histories
                  </ModalHeader>
                  <ModalBody>
                    <div className="profile-timeline">
                      <div></div>
                      <div className="accordion accordion-flush" id="todayExample">
                        {info &&
                          info.transfer_history &&
                          info.transfer_history.map((item, i) => {
                            return (
                              <div key={i} className="accordion-item border-0">
                                <div className="accordion-header">
                                  <button className="accordion-button p-2 shadow-none" type="button" id="headingOne">
                                    <div className="d-flex">
                                      <div className="flex-shrink-0">
                                        {item.transfer_history_createdby && item.transfer_history_createdby.employee_image && item.transfer_history_createdby.employee_image.path ? (
                                          <img src={process.env.REACT_APP_API_URL + "/files/" + item.transfer_history_createdby.employee_image.path} alt="" className="rounded-circle avatar-xs" />
                                        ) : (
                                          <div className="flex-shrink-0 avatar-xs">
                                            <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{item.transfer_history_createdby.name.charAt(0)}</div>
                                          </div>
                                        )}
                                      </div>
                                      <div className="flex-grow-1 ms-3">
                                        <h6 className="fs-14 mb-1">{item.transfer_history_createdby.name}</h6>
                                        <p className="fw-normal text-muted mb-1">
                                          Change transfer status to <span className="fw-semibold text-info">{item.transfer_history_status.name}</span> with note:
                                        </p>
                                        <p className="fw-normal mb-1">{item.notes || "-"}</p>
                                        <small className="text-muted">{moment(item.createdat, "YYYY/MM/DD HH:mm:ss").fromNow()}</small>
                                      </div>
                                    </div>
                                  </button>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setModalHistory(false);
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </Modal>
                <Modal id="showModalApprove" isOpen={modalApprove} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleApprove}>
                    ACTION CONFIRMATION
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationApprove.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="mt-2 text-center">
                        <lord-icon src="https://cdn.lordicon.com/puvaffet.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style={{ width: "100px", height: "100px" }}></lord-icon>
                        <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                          <p className="fs-16">{transfer && transfer.actionTitle}</p>
                        </div>
                        <div className="mt-3 col-lg-12">
                          <Input name="approval_note" id="approval_note-field" className="form-control" placeholder="Enter Notes If Any" rows={4} type="textarea" onChange={validationApprove.handleChange} onBlur={validationApprove.handleBlur} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalApprove(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Submit</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    Penyesuaian Stok Detail
                  </ModalHeader>
                  {transfer !== undefined && transfer !== null ? (
                    <ModalBody>
                      <Row id="printThis">
                        <Col lg={12}>
                          <CardHeader className="border-bottom-dashed p-4">
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="40" />
                                <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="40" />
                                <div className="mt-sm-3 mt-3">
                                  <h6 className="text-uppercase fw-semibold">{transfer.client && transfer.client.label}</h6>
                                  <p className="mb-1">{transfer.company && transfer.company.label}</p>
                                  <p className="mb-1">{transfer.department && transfer.department.label}</p>
                                </div>
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody className="p-4">
                            <Row className="g-3">
                              <Col lg={3} xs={3}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Transfer No</p>
                                <h5 className="fs-14 mb-0">
                                  #<span id="invoice-no">{transfer.transaction_no}</span>
                                </h5>
                              </Col>
                              <Col lg={3} xs={3}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Date</p>
                                <h5 className="fs-14 mb-0">
                                  <span id="invoice-date">{handleValidDate(transfer.transactionat)}</span>
                                </h5>
                              </Col>
                            </Row>
                          </CardBody>
                          <CardBody className="p-4">
                            <div>
                              <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                                <thead>
                                  <tr className="table-active">
                                    <th scope="col" style={{ width: "50px" }}>
                                      #
                                    </th>
                                    <th scope="col">Detail Produk</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Satuan</th>
                                  </tr>
                                </thead>
                                <tbody id="products-list">
                                  {(productInventoryDetailItem || []).map((o, i) => {
                                    return (
                                      <tr key={i} id={i} className="product">
                                        <th scope="row" className="product-id">
                                          {i + 1}
                                        </th>
                                        <td className="text-start">{o.name}</td>
                                        <td>{o.quantity}</td>
                                        <td>{o.uom}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                            </div>
                            <div className="mt-4">
                              <div className="alert alert-info">
                                <p className="mb-0">
                                  <span className="fw-semibold">NOTES:</span>
                                  <span id="note"> {transfer.description}</span>
                                </p>
                              </div>
                            </div>
                            <div className="mt-4">
                              <div>
                                <p className="mb-0">{transfer.user}</p>
                              </div>
                            </div>
                          </CardBody>
                        </Col>
                      </Row>
                    </ModalBody>
                  ) : null}
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setModalDetail(false);
                        }}
                      >
                        Tutup
                      </button>
                      <button
                        type="submit"
                        className="btn btn-info"
                        onClick={() => {
                          handlePrint();
                        }}
                      >
                        Print Document&nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
                      </button>
                    </div>
                  </div>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <PrintDoc innerRef={printRef} item={transfer} />
      </Container>
    </div>
  );
};

export default Transfer;
